import React from 'react'

import { Container, DateTimesVariant, renderImage } from './Common'

import TripItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { ThingToDoItem } from 'tripPlanner/types/tripItem'
import { getDisplayableCustomThingToDoName } from 'tripPlanner/utils/itemConversions/common'

interface Props {
  item: ThingToDoItem
}

const ThingToDoSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ item }: Props, ref) => {
    const {
      startPlace,
      endPlace,
      type,
      startDate,
      startTime,
      endDate,
      endTime,
      isBooked,
      startDay,
      endDay,
    } = item

    const openModal = useOpenModal()

    const onClick = () => openModal(TripItemSummary, { item })

    return (
      <Container ref={ref}>
        {renderImage(startPlace)}
        <DateTimesVariant
          name={getDisplayableCustomThingToDoName(item)}
          startPlace={startPlace}
          endPlace={endPlace}
          startDate={startDate}
          startTime={startTime}
          endDate={endDate}
          endTime={endTime}
          type={type}
          isBooked={isBooked}
          onClick={onClick}
          startDay={startDay}
          endDay={endDay}
        />
      </Container>
    )
  },
)

export default ThingToDoSummaryCard
